import React from "react";

function FiltersQualifyLeadsIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#EF4F80" rx="10"></rect>
            <path
                fill="#fff"
                d="M29 20.951c-4.438 0-8.049 3.61-8.049 8.049 0 4.438 3.61 8.049 8.049 8.049 4.438 0 8.049-3.61 8.049-8.049 0-4.438-3.61-8.049-8.049-8.049zm4.176 6.371l-4.39 4.39a.728.728 0 01-1.035 0l-2.927-2.926a.732.732 0 111.035-1.035l2.41 2.41 3.872-3.873a.732.732 0 111.035 1.034zm10.656 1.212l-2.373-2.872.62-3.674a.732.732 0 00-.467-.808l-3.491-1.3-1.301-3.492a.73.73 0 00-.808-.466l-3.674.62-2.872-2.374a.732.732 0 00-.932 0l-2.872 2.373-3.674-.62a.73.73 0 00-.808.467l-1.3 3.491-3.492 1.301a.732.732 0 00-.466.808l.62 3.674-2.374 2.872a.732.732 0 000 .932l2.373 2.872-.62 3.674a.732.732 0 00.467.808l3.491 1.3 1.301 3.492a.73.73 0 00.808.466l3.674-.62 2.872 2.374a.732.732 0 00.932 0l2.872-2.373 3.674.62a.731.731 0 00.808-.467l1.3-3.492 3.492-1.3a.731.731 0 00.466-.808l-.62-3.674 2.374-2.872a.732.732 0 000-.932zM29 38.512c-5.245 0-9.512-4.267-9.512-9.512s4.267-9.512 9.512-9.512 9.512 4.267 9.512 9.512-4.267 9.512-9.512 9.512z"
            ></path>
        </svg>
    );
}

export default FiltersQualifyLeadsIcon;
